<template>
  <section class="emotional-monitoring">
    <div class="emotional-monitoring__header">
      <h2 class="emotional-monitoring__title">
        Мониторинг эмоциональной динамики
      </h2>

      <div class="emotional-monitoring__filters">
        <a-select
            v-model:value="selectedGroup"
            :options="groupOptions"
            class="emotional-monitoring__select"
        />

        <a-select
            v-model:value="selectedPeriod"
            :options="periodOptions"
            class="emotional-monitoring__period"
        />
      </div>
    </div>

    <div class="emotional-monitoring__grid">
      <SmallCardWrapper
          name="Энергия компании"
          :helpText="'Энергия компании'"
      >
        <CompanyEnergyCard
            :total="energy.total"
            :levels="energy.levels"
            :chartLabels="energy.chartLabels"
            :chartValues="energy.chartValues"
        />
      </SmallCardWrapper>

      <SmallCardWrapper
          name="Топ эмоций"
          :helpText="'Топ эмоций'"
      >
        <TopEmotionsCard
            :warning="topEmotions.warning"
            :items="topEmotions.items"
        />
      </SmallCardWrapper>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import SmallCardWrapper from '@/components/Widgets/WidgetCard.vue'
import TopEmotionsCard from "@/components/Analytics/TopEmotionCards.vue";
import CompanyEnergyCard from "@/components/Analytics/CompanyEnergyCard.vue";
import {computed, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import AssertionsDynamicsCard from "@/components/Analytics/AssertionsDynamicsCard.vue";

export default {
  name: 'EmotionalDynamicsMonitoring',

  components: {
    AssertionsDynamicsCard,
    CompanyEnergyCard,
    TopEmotionsCard,
    SmallCardWrapper,
  },

  setup() {
    const store = useStore();
    const groups = computed(() => store.state.group.groups);

    const selectedGroup = ref('all')
    const selectedPeriod = ref('week')

    const groupOptions = computed(() => {
      return [
        {
          label: 'Все сотрудники',
          value: 'all',
        },
        ...groups.value.map((group) => ({
          label: group.name,
          value: group.id,
        })),
      ]
    });

    const periodOptions = [
      {
        label: 'Неделя',
        value: 'week',
      },
      {
        label: 'Месяц',
        value: 'month',
      },
      {
        label: 'Квартал',
        value: 'quarter',
      },
    ]

    const energy = ref({
      total: 76,
      levels: [
        {
          key: 'very_high',
          label: 'Очень высокий',
          value: 3,
          color: '#21AC0C',
        },
        {
          key: 'high',
          label: 'Высокий',
          value: 10,
          color: '#99DA6E',
        },
        {
          key: 'medium',
          label: 'Средний',
          value: 39,
          color: '#DDE00F',
        },
        {
          key: 'low',
          label: 'Низкий',
          value: 12,
          color: '#FF9F40',
        },
        {
          key: 'very_low',
          label: 'Очень низкий',
          value: 5,
          color: '#F55565',
        },
      ],
      chartLabels: ['07.03', '14.03', '21.03', '28.03', '04.04', '11.04'],
      chartValues: [50, 35, 31, 32, 46, 85],
    })

    const topEmotions = ref({
      warning: {
        text: 'В компании растет напряжение. Рекомендуется:',
        recommendations: [
          'Собрать обратную связь на встречах.',
          'Провести встречи 1-на-1.',
        ],
      },
      items: [
        {
          name: 'Раздражение',
          change: 16,
          highlighted: true,
        },
        {
          name: 'Спокойствие',
          change: 9,
          highlighted: true,
        },
        {
          name: 'Усталость',
          change: 16,
          highlighted: true,
        },
        {
          name: 'Радость',
          change: -3,
          highlighted: false,
        },
        {
          name: 'Интерес',
          change: 65,
          highlighted: false,
        },
      ],
    });

    return {
      selectedGroup,
      selectedPeriod,
      groupOptions,
      periodOptions,
      energy,
      topEmotions,
    }
  },
}
</script>

<style scoped lang="scss">
.emotional-monitoring {
  width: 100%;
  text-align: start;
}

.emotional-monitoring__header {
  margin-bottom: 20px;
}

.emotional-monitoring__title {
  margin: 0 0 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.emotional-monitoring__filters {
  display: flex;
  align-items: center;
  gap: 14px;
}

.emotional-monitoring__select {
  width: 350px;
}

.emotional-monitoring__period {
  width: 200px;
}

.emotional-monitoring__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.emotional-monitoring__grid :deep(.ant-card-body) {
  padding: 0;
}

.emotional-monitoring__grid :deep(.small-card-wrapper__body) {
  align-items: stretch;
}

@media (max-width: $tablet-breakpoint) {
  .emotional-monitoring__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: $mobile-breakpoint) {
  .emotional-monitoring__filters {
    flex-direction: column;
    align-items: stretch;
  }

  .emotional-monitoring__select,
  .emotional-monitoring__period {
    width: 100%;
  }
}
</style>